import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import libs from './libs';
import createHistory from 'history/createBrowserHistory';
import "@babel/polyfill";

const config = require('./config');
const userSession = libs.storageHelper.getFromStorage('loggedUser');

// TODO: REMOVE window.__config and get the config from helper class
window.commonHelpers = {
  libs: libs,
  config: config,
  loggedUser: (userSession && userSession.hasOwnProperty('user') && userSession.hasOwnProperty('authentication')) ? userSession : null
};

const history = createHistory();
window.appHistory = history;

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById("root")
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js